import { Module } from '@library/store/modules/modules.interface';

export function sortModulesByTypes(modules: Module[], types: string[]) {
  return [...modules]
    .sort((a, b) => {
      const indexA = types.indexOf(a.type);
      const indexB = types.indexOf(b.type);
      return indexA >= indexB ? 1 : -1;
    });
}
